import React from 'react';
import { useNavigate } from 'react-router-dom';
import RebateBanner from '../components/RebateBanner';
import ToolIcon from '../components/ToolIcon';
import { useLang } from '../i18n/context';
import './ToolsPage.css';
import '../styles/pro-page.css';

const tools = [
  {
    title: 'K线形态匹配',
    subtitle: 'Pattern Match',
    desc: '用最近一段 BTC K 线走势匹配历史相似片段，查看后续真实表现。',
    path: '/pattern-match',
    status: '已上线',
    tone: 'gold',
    icon: 'pattern',
    iconLabel: 'K线形态匹配图标',
  },
  {
    title: '出货侦探 2.0',
    subtitle: 'Dump Detective',
    desc: '输入 BSC 代币合约地址，生成合约安全、流动性和出货风险侦测报告。',
    path: '/dump-detective',
    status: 'Beta · DexScreener',
    tone: 'blue',
    icon: 'detective',
    iconLabel: '出货侦探图标',
  },
  {
    title: '支撑 / 压力位',
    subtitle: 'Support / Resistance',
    desc: '查询主流加密货币多周期关键支撑与压力位，查看距离当前价和强度。',
    path: '/support-resistance',
    status: 'Beta · Binance',
    tone: 'orange',
    icon: 'levels',
    iconLabel: '支撑压力位图标',
  },
  {
    title: '黄金内外盘换算器',
    subtitle: 'Gold Calculator',
    desc: '用今日基准价换算国际现货黄金与国内账户黄金，查看每克价差和溢价率。',
    path: '/gold-calculator',
    status: 'Beta · Jin10 MCP',
    tone: 'gold',
    icon: 'levels',
    iconLabel: '黄金换算器图标',
  },
  {
    title: '黄金4小时趋势雷达',
    subtitle: 'Gold Trend Radar',
    desc: '基于维加斯通道 EMA144/169/576/676 判断黄金中期趋势，一眼看懂多空。',
    path: '/gold-trend',
    status: 'Beta · Jin10 MCP',
    tone: 'gold',
    icon: 'levels',
    iconLabel: '黄金趋势雷达图标',
  },
];

function ToolsPage() {
  const navigate = useNavigate();
  const { t } = useLang();

  const copyWechat = () => {
    navigator.clipboard.writeText('admiraltyz');
  };

  return (
    <main className="pro-page">
      <header className="pro-hero">
        <p className="pro-hero-label">Toolbox</p>
        <h1>工具箱</h1>
        <span className="pro-hero-desc">把链上分析、行情回测和风险检测工具集中到这里，后续新工具都从这里进入。</span>
      </header>

      <div className="pro-page-inner">
      <section className="tools-grid">
        {tools.map((tool) => (
          <article
            className={`tools-card ${tool.tone}`}
            key={tool.path}
            onClick={() => navigate(tool.path)}
          >
            <div className="tools-card-icon">
              <ToolIcon type={tool.icon} label={tool.iconLabel} />
            </div>
            <div className="tools-card-name">{tool.title}</div>
            <div className="tools-card-desc">{tool.desc}</div>
            <span className={`tools-card-tag tools-tag-${tool.tone}`}>{tool.status}</span>
          </article>
        ))}
      </section>

      <section className="tools-pro-banner">
        <div className="tools-pro-badge">PRO</div>
        <div className="tools-pro-text">
          <strong>{t('tools.proBannerTitle')}</strong>
          <span>{t('tools.proBannerDesc')}</span>
        </div>
        <button className="tools-pro-btn" onClick={copyWechat}>{t('tools.proBannerCta')}</button>
      </section>

      <RebateBanner />
      </div>
    </main>
  );
}

export default ToolsPage;
